<template>
    <div class="week-date-picker">
            <div class="date-navigation">
                <div class="arrow el-icon-arrow-left" @click="previousWeek"></div>
                <div class="week-dates">
                    <div id="dateBox" class="date-item">                    
                        <span  v-for="(date, index) in weekArr" :key="index">
                            <!-- <span :class="date.state == 1?'one': date.state == 2?'two': date.state == 0?'three':''"    @click="selectDate(date,index)">{{ date.data }}</span> -->
                            <span  v-if="date.state == 0" @click="selectDate(date, index)" :class="paidaindex == index ? 'two' : 'three'"  >{{ date.data }}</span>
                            <span  v-if="date.state == 1"  @click="selectDate(date, index)" style="background-color: rgb(216, 87, 89 , 0.9);">{{ date.data }}</span>
                            <span  v-if="date.state == 2"  @click="selectDate(date, index)" style="background-color: rgba(255, 6, 6 , 0.6);">{{ date.data }}</span>





                            <!-- <i   v-if="date.state == 1" class="el-icon-check"></i> -->
                        </span>
                    </div>
                    <!-- <div v-for="date in weekDates" :key="date" :class="{ 'date-item': true, 'selected': isSelected(date) }" @click="selectDate(date)">
                    {{ formatDate(date) }}
                </div> -->
                </div>
                <div class="arrow el-icon-arrow-right" @click="nextWeek"></div>
            </div>
        </div>
</template>
<script>
import { weekdaybydate, queryTreeflxx, } from "@/api/context1"//一二级分类
import { queryXwxxbyCondition, } from "@/api/news"//新闻
import { getUserInfo } from "@/common/utils/localStorage.js";
export default {
    data() {
        return {
            weekArr: [],
            haveDataIndex: [],
            currentDate: new Date(),
            weekDates: [],
            selectedDate: null,
            calendarData: [],//活动日历集合
            calendarActiveData: [],//活动日历信息
            startTime: "",//活动日历开始时间
            endTime: "",//活动日历结束时间
            clickTime: [
                {
                    time: '-10'
                },
                {
                    time: '-9'
                },
                {
                    time: '-8'
                },
                {
                    time: '-7'
                },
                {
                    time: '-6'
                },
                {
                    time: '-5'
                },
                {
                    time: '-4'
                },
            ],
            creatTime: "",
            paidaindex: 0
        };
    },
    created() {
        let vm = this;
        vm.weekdaybydate()
    },
    mounted() {
    },
    methods: {
        previousWeek() {
            let vm = this;
            let type = 1
            vm.creatTime = this.getYear(0) + '-' + vm.weekArr[0].data
            vm.weekdaybydate(type)
            let flag = true
        },
        nextWeek() {
            let vm = this;
            let type = 2
            vm.creatTime = this.getYear(0) + '-' + vm.weekArr[6].data
            vm.weekdaybydate(type)
            let flag = true
        },
        selectDate(date, index) {
            this.paidaindex = index

            this.$emit('date-selected', date);
            // date.state = 2
        },
        //获取一周时间
        weekdaybydate(type) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                creatTime: vm.creatTime,
                type: type
            }
            weekdaybydate(obj).then((res) => {
                vm.weekArr = res.data
                // this.$emit('date-selected', vm.weekArr[0]);
            });
        },
        getYear(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这⾏是关键代码
            var tYear = today.getFullYear();
            return tYear
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },
    },
    mounted() {

    },
};
</script >
  
<style scoped  lang='scss'>
.default {
    width: 60px;
    margin: 0 10px;
}

.date-navigation {
    display: flex;
    align-items: center;
    justify-content: center;
}

.arrow {
    border: 1px solid #ccc;
    width: 25px;
    height: 28px;
    line-height: 28px !important;
    text-align: center;
    cursor: pointer;
}

.week-dates {
    display: flex;
}

.date-item {
    // flex: 1;
    text-align: center;
    width: 99%;
    height: 30px;
    line-height: 30px;
    margin: 0 11px;
    text-align: center;
    // background-color: rgba(0,0,0,0.1);
    float: left;
    cursor: pointer;
    font-size: 14px;
}

.date-item span {
    display: inline-block;
    margin: 0 10px;
    width: 60px;
    font-size: 18px;
}

.selected {
    background-color: rgb(39, 48, 96);
    color: #ffffff !important;
    // width: 100%;
}


.bgTheme {
    background-color: rgb(225, 6, 75);
}


.one {
    background-color: red;
}

.two {
    background-color: rgba(255, 6, 6, 0.3);
    ;
}

.three {
    background-color: rgb(255, 255, 255);
}

.four {
    background-color: rgb(126, 226, 5);
}</style>



// WEBPACK FOOTER //
// src/components/calendar.vue